const S_SLIDER = '.js-slider'
const S_SLIDER_TNS = '.js-slider-tns'
const S_SLIDER_CONTROL = '.js-control'
const S_PHOTO_LINK_TNS = '.js-photo-link-tns'
const S_SLIDER_PREV = '[data-to="prev"]'
const S_SLIDER_NEXT = '[data-to="next"]'
const A = 'active'
const D = document
const W = window
let timeout;

function on (el, event, cb) {
  if (el) {
    el.removeEventListener(event, cb)
    el.addEventListener(event, cb)
  }
}

function addClass(C) {
  this.classList.add(C)
}

function removeClass(C) {
  this.classList.remove(C)
}

function goTo () {
  if(this.sliderMain && this.sliderMain.sliders){
    let to = this.getAttribute('data-to');
    this.sliderMain.sliders.forEach(function (value) {
      value.goTo(to);
    })
  }
}

function setActive (elem, index) {
  let control = elem.querySelector(S_SLIDER_CONTROL+`[data-to="${index}"]`)
  if(control){
    elem.querySelectorAll(S_SLIDER_CONTROL).forEach(function (value) {
      if(value === control){
        addClass.call(value, A)
      }else{
        removeClass.call(value, A)
      }
    })
  }
  elem.sliders.forEach(function (value) {
    if(value.getInfo().index !== index){
      value.goTo(index);
    }
  })
}

function resize () {
  clearTimeout(timeout)
  timeout = setTimeout(function () {
    W.trigger(W, 'resize')
  }, 300)
}

function init () {
  if(!W.tns){
    on(D, 'tns:init', init)
    return true
  }
  D.querySelectorAll(S_SLIDER).forEach(function (sliderMain) {
    if(sliderMain.sliders){
      sliderMain.sliders.forEach(function (value) {
        value.destroy();
      })
    }
    sliderMain.sliders = [];

    let prev = sliderMain.querySelector(S_SLIDER_PREV);
    let next = sliderMain.querySelector(S_SLIDER_NEXT);

    sliderMain.querySelectorAll(S_SLIDER_TNS).forEach(function (sliderMainTns) {
      let slider = W.tns({
        "autoWidth": false,
        "autoHeight": true,
        "items": 1,
        "gutter": 0,
        "touch": true,
        "mouseDrag": false,
        "loop": false,
        "center": false,
        "swipeAngle": false,
        "controls": false,
        "nav": false,
        "navAsThumbnails": false,
        "autoplay": false,
        "container": sliderMainTns,
        "speed": 400
      });
      sliderMain.sliders.push(slider);

      slider.events.on('indexChanged', (v) => {
        let index = v.index;
        setActive(sliderMain, index)
        const items = sliderMain.querySelector(S_SLIDER_TNS).children;
        if(prev){
          prev.disabled = (index === 0)
        }
        if(next){
          next.disabled = (items.length - 1) === index
        }
        resize()
      });
    })

    sliderMain.querySelectorAll(S_SLIDER_CONTROL).forEach(function (control) {
      control.sliderMain = sliderMain
      on(control, 'click', goTo)
    })

    sliderMain.querySelectorAll(S_PHOTO_LINK_TNS).forEach(function (link) {
      link.sliderMain = sliderMain
    })

  });

  if(W.lazyLoadInstance){
    W.lazyLoadInstance.update()
  }

  resize()
}

export default init
